module.exports = __webpack_public_path__ + "img/message2.68108385.svg";